import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Common/Modal/Modal';
import Moment from 'moment';
import { DATE_FORMAT } from '../../../constants/constants';

const ChangeTargetDateModal = ({ task, deltaDays, onCancel, onComplete }) => {
    

    const renderBody = () => {
        const from = Moment.utc(task.targetDate).format(DATE_FORMAT);
        const to = Moment.utc(task.targetDate).add(deltaDays, 'days').format(DATE_FORMAT);
        return (
            <div>Are you sure you want to change the Target Date from {from} to {to}?</div>   
        )
    }

    return (
        <Modal
            id="changeTargetDateModal"
            title="Confirm Change"
            body={renderBody()}
            onCloseClick={onCancel}
            onPrimaryClick={onComplete}
            onSecondaryClick={onCancel}
        />   
    )
}

ChangeTargetDateModal.propTypes = {
    task: PropTypes.object.isRequired,
    deltaDays: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired
};

export default ChangeTargetDateModal;